import { v4 as uuidv4 } from 'uuid';
import { randFullName, randJobArea, randJobTitle, randSkill } from '@ngneat/falso';

interface Competence {
  Id: string;
  Name: string;
  Value: number;
}

interface Capacity {
  AvailableHours: number;
  TotalHours: number;
}

interface Properties {
  UserId: string;
  FullName: string;
  Position: string;
  LegalEntity: string;
  Department: string;
  Capacity: Capacity;
  Competences: Competence[];
}

interface Entity {
  Properties: Properties;
}

const getRandomInt = (min: number, max: number): number =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const generateRandomCompetences = (count: number): Competence[] => {
  const competences: Competence[] = [];
  for (let i = 0; i < count; i += 1) {
    competences.push({
      Id: uuidv4(),
      Name: randSkill(),
      Value: getRandomInt(1, 5),
    });
  }
  return competences;
};

const generateRandomEntity = (): Entity => ({
  Properties: {
    UserId: uuidv4(),
    FullName: randFullName(),
    Position: randJobTitle(),
    LegalEntity: 'TimeLog A/S',
    Department: randJobArea(),
    Capacity: {
      AvailableHours: getRandomInt(1, 37),
      TotalHours: getRandomInt(1, 37),
    },
    Competences: generateRandomCompetences(getRandomInt(1, 5)),
  },
});

export const generateRandomEntities = (count: number): Entity[] => {
  const entities: Entity[] = [];
  for (let i = 0; i < count; i += 1) {
    entities.push(generateRandomEntity());
  }
  return entities;
};
